export default __webpack_public_path__ + "static/media/solteiroduplo_1.13fc9dc5.jpg";